import { focusElemnt } from '../../common/helper'
import { faBullseye } from "@fortawesome/free-solid-svg-icons"

export const bookingPageTab = [
  'Method Of Packing',
  'Consignment Type',
  'Weight Charges',
  //'Luggage Cities',
  //'Marquee',
  //'Payment Mode',
  'Valuation Charge',
  'Document Charge',
  'Pickup and Dropoff Charge',
  'Booking Hamali',
  'FOC Approval',
// export const bookingPageTab = [
//   'Method Of Packing',
//   'Consignment Type',
//   'Weight Charges',
//   //'Luggage Cities',
//   //'Marquee',
//   //'Payment Mode',
//   'Valuation Charge',
//   'Document Charge',
//   'Pickup and Dropoff Charge',
//   'FOC Approval',
]
export const GeneralSettingAllTabs = [
  { name: "Booking Page", JobID: 1 },
  { name: "Delivery Page", JobID: 2 },
  { name: "Rates Matrix", JobID: 3 },
  { name: "Party Master", JobID: 51 },
  { name: "Route Master", JobID: 585 },
  { name: "Auto Transaction", JobID: 5 },
  { name: "Reports Config", JobID: 6 },
  { name: "WayBill Format", JobID: 7 },
  { name: "Crossing Master", JobID: 256 },
  { name: "Expense Heads", JobID: 47 },
  { name: "SMS Policy", JobID: 61 },

  // {name:"Other",JobID:8},
]
export const bookingPageTabs = [
  {name:"Method Of Packing",JobID:209},
  {name:"Consignment Type",JobID:50},
  {name:"Weight Charges",JobID:443},
  {name:"Valuation Charge",JobID:211},
  {name:"Luggage Cities",JobID:142},
  // {name:"Marquee",JobID:206},
  {name:"Payment Mode",JobID:511},
  {name:"Pickup and Dropoff Cartage",JobID:576},
  {name:"Document Charge",JobID:218},
  {name:"Pickup and Dropoff Charge",JobID:453},
  // {name:"FOC Approval",JobID:294},
  {name:"Booking Hamali",JobID:545},
]
// export const bookingPageTabIds = (index) => {
//   return {
//     id: `bookingPage-tab-${index}`,
//     'aria-controls': `bookingPage-tabpanel-${index}`,
//   }
// }
export const bookingPageTabIds = (id) => {
  return {
    id: `bookingPage-tab-${id}`,
    'aria-controls': `bookingPage-tabpanel-${id}`,
  }
}
export const macDetailTabIds = (id) => {
  return {
    id: `macDetail-tab-${id}`,
    'aria-controls': `macDetail-tabpanel-${id}`,
  }
}
export const repeatdata = [
  { id: 0, name: 'contains', headerName: 'SN' },
  { id: 1, name: 'contains', headerName: 'Company Name' },
  { id: 2, name: 'contains', headerName: 'Branch Name' },
  { id: 3, name: 'contains', headerName: 'City Name' },
  { id: 4, name: 'contains', headerName: 'State Name' },
  { id: 5, name: 'contains', headerName: 'Consignment Type' },
  { id: 6, name: 'contains', headerName: 'Payment Type' },
  { id: 7, name: 'contains', headerName: 'Modified By' },
  { id: 8, name: 'contains', headerName: 'Modified Date & Time' },
  { id: 9, name: 'contains', headerName: 'Status' },
  { id: 10, name: 'contains', headerName: 'Edit' },
]

export const consTypeMOPData = [{ value: "Yes", id: 1 }, { value: "No", id: 0 }]

export const deliveryTypeList = [
  { id: 0, name: 'All' },
  { id: 1, name: 'Own Branch' },
  { id: 2, name: 'Franchisee' },
]
export const bookingTypeList = [
  { id: 0, name: 'All' },
  { id: 1, name: 'Own Branch' },
  { id: 2, name: 'Franchisee' },
]
export const chargeTypeList = [
  { id: 1, name: 'Per KG' },
  { id: 2, name: 'Per Unit' },
  { id: 3, name: 'Per LR' },
]
export const hamaliTypeList = [
  { id: 0, name: 'Delivery Hamali' },
  { id: 1, name: 'Delivery Ext. Hamali' },
]
export const bookingHamaliTypeList = [
  { id: 0, name: 'Booking Hamali' },
  { id: 1, name: 'Booking Op Hamali' },
]
export const docChargeheaderdata = [
  {
    id: 0,
    name: 'contains',
    allowSorting: false,
    dataType: 'number',
    field: 'SN',
    headerSx: { minWidth: '54px' },
    showfilter: false,
    headerName: 'SN',
  },
  {
    id: 1,
    name: 'contains',
    allowSorting: false,
    dataType: 'string',
    field: 'ChargeTypeDesc',
    headerSx: { minWidth: '244px' },
    showfilter: true,
    headerName: 'Doc. Charge Type',
  },
  {
    id: 2,
    name: 'contains',
    allowSorting: false,
    dataType: 'string',
    field: 'BillingUnitDesc',
    headerSx: { minWidth: '300px' },
    showfilter: true,
    headerName: 'Consignment Unit ',
  },
  {
    id: 3,
    name: 'contains',
    allowSorting: false,
    dataType: 'string',
    field: 'PaymentType',
    headerSx: { minWidth: '171px' },
    showfilter: true,
    headerName: 'Payment Type',
  },
  {
    id: 4,
    name: 'contains',
    allowSorting: true,
    dataType: 'number',
    field: 'DocumentCharge',
    headerSx: { minWidth: '160px' },
    showfilter: true,
    headerName: 'Doc. Chrg.',
  },
  {
    id: 5,
    name: 'contains',
    allowSorting: true,
    dataType: 'string',
    field: 'ModifiedUser',
    headerSx: { minWidth: '200px' },
    showfilter: true,
    headerName: 'Modified By',
  },
  {
    id: 6,
    name: 'contains',
    allowSorting: true,
    dataType: 'time',
    field: 'ModifiedDate',
    headerSx: { minWidth: '200px' },
    showfilter: false,
    headerName: 'Modified Date & Time',
  },
  {
    id: 7,
    name: 'contains',
    allowSorting: false,
    dataType: 'string',
    field: 'IsActive',
    headerSx: { minWidth: '82px' },
    showfilter: false,
    headerName: 'Active',
  },
  {
    id: 8,
    name: 'contains',
    allowSorting: false,
    dataType: 'string',
    field: 'Edit',
    headerSx: { minWidth: '54px' },
    showfilter: false,
    headerName: 'Edit',
  },
]

export const handlekeyDown = (e, prevId, nextId, inputID, callFunction) => {
  if (e.key === 'Enter') {
    focusElemnt(nextId)
  } else if (e.key === 'Escape') {
    focusElemnt(prevId)
  } else if (e.key === ' ') {
    callFunction()
    // focusElemnt(inputID)
  }
}
export const documentsChargeType = [
  { id: 1, Name: 'Per LR' },
  { id: 2, Name: 'Per Unit' },
]
export const ConsignmentUnit = [
  { id: 1, Name: 'Per kg.' },
  { id: 2, Name: 'Per Quantity' },
]
//Delivery Page
// export const deliveryPageTab = ['Demurrage Charges', 'Delivery Charges']
export const deliveryPageTabs = [{name:"Demurrage Charges",JobID:318},{name:"Delivery Hamali",JobID:340},]
export const deliveryPageTabIds = (id) => {
  return {
    id: `bookingPage-tab-${id}`,
    'aria-controls': `bookingPage-tabpanel-${id}`,
  }
}
export const bookingType = [
  { id: 0, name: 'All' },
  { id: 1, name: 'Own Bookings' },
  { id: 2, name: 'Franchisee Bookings' },
]
export const bookingType1 = [
  { id: 1, name: 'Own Bookings' },
  { id: 2, name: 'Franchisee Bookings' },
]
export const chargeType = [
  { id: 0, name: 'All' },
  { id: 1, name: 'Per LR' },
  { id: 2, name: 'Per Unit' },
]
export const chargeType1 = [
  { id: 1, name: 'Per LR' },
  { id: 2, name: 'Per Unit' },
]
export const fixedCharge = [
  { id: 0, name: 'No' },
  { id: 1, name: 'Yes' },
]
export const valuationTableData = [
  {
    id: 0,
    name: 'contains',
    allowSorting: false,
    headerSx: { textAlign: 'right', minWidth: '40px' },
    field: 'SN',
    showfilter: false,
    field: '',
    headerName: 'SN',
  },
  {
    id: 1,
    name: 'contains',
    allowSorting: false,
    headerSx: { textAlign: 'left', minWidth: '235px' },
    field: 'SN',
    showfilter: true,
    field: 'CompanyName',
    headerName: 'Company Name',
  },
  {
    id: 2,
    name: 'contains',
    allowSorting: false,
    headerSx: { textAlign: 'left', minWidth: '235px' },
    field: 'SN',
    showfilter: true,
    field: 'BranchName',
    headerName: 'Branch Name',
  },
  {
    id: 3,
    name: 'contains',
    allowSorting: false,
    headerSx: { textAlign: 'left', minWidth: '107px' },
    field: 'SN',
    showfilter: true,
    field: 'CityName',
    headerName: 'City Name',
  },
  {
    id: 4,
    name: 'contains',
    allowSorting: false,
    headerSx: { textAlign: 'left', minWidth: '100px' },
    field: 'SN',
    showfilter: true,
    field: 'StateName',
    headerName: 'State Name',
  },
  {
    id: 5,
    name: 'contains',
    allowSorting: false,
    headerSx: { textAlign: 'left', minWidth: '125px' },
    field: 'SN',
    showfilter: true,
    field: 'SubType',
    headerName: 'Consignment Type',
  },
  {
    id: 6,
    name: 'contains',
    allowSorting: false,
    headerSx: { textAlign: 'left', minWidth: '94px' },
    field: 'SN',
    showfilter: true,
    field: 'PaymentType',
    headerName: 'Payment Type',
  },
  {
    id: 7,
    name: 'contains',
    allowSorting: false,
    headerSx: { textAlign: 'left', minWidth: '106px' },
    field: 'SN',
    showfilter: true,
    field: 'ModifiedUser',
    headerName: 'Modified By',
  },
  {
    id: 8,
    name: 'contains',
    allowSorting: false,
    headerSx: { textAlign: 'left', minWidth: '153px' },
    field: 'SN',
    showfilter: false,
    field: '',
    headerName: 'Modified Date & Time',
  },
  {
    id: 9,
    name: 'contains',
    allowSorting: false,
    headerSx: { textAlign: 'left', minWidth: '60px' },
    field: 'SN',
    showfilter: false,
    field: '',
    headerName: 'Status',
  },
  {
    id: 10,
    name: 'contains',
    allowSorting: false,
    headerSx: { textAlign: 'left', minWidth: '78px' },
    field: 'SN',
    showfilter: false,
    field: '',
    headerName: 'Edit',
  },
]
export const autoTransPageTab = ['Auto Branch Transfer / Branch Receive', 'Auto Receive', 'Auto Delivery']
export const autoTransPageTabs = [{name:"Auto Branch Transfer / Branch Receive",JobID:481},{name:"Auto Receive",JobID:532},{name:"Auto Delivery",JobID:533},]
export const autoTransPageTabIds = (index) => {
  return {
    id: `autoTransPage-tab-${index}`,
    'aria-controls': `autoTransPage-tabpanel-${index}`,
  }
}
export const satusList = [
  { id: 1, name: 'Active' },
  { id: 0, name: 'Inactive' },
]

export const paymentModecolumn = [
  { headerName: '', dataType:"string",field: "", headerSx: { textAlign:"center",minWidth: "73px" }, showString:faBullseye,showfilter: false,allowSorting:false },
  { headerName: 'Branch Name', dataType:"string",field: "BranchName", headerSx: { textAlign:"left",minWidth: "300px" }, showString:faBullseye,allowSorting:false,showfilter: true },
  { headerName: 'City Name', dataType:"string",field: "CityName", headerSx: { textAlign:"left",minWidth: "100px" }, showString:faBullseye,allowSorting:false,showfilter: true },
  { headerName: 'Credit and Debit', dataType:"string",field: "Credit and Debit", headerSx: { textAlign:"left",minWidth: "120px" }, showString:faBullseye,allowSorting:false,showfilter: false },
  { headerName: 'Net Banking', dataType:"string",field: "Net Banking", headerSx: { textAlign:"left",minWidth: "120px" }, showString:faBullseye,allowSorting:false,showfilter: false },
  { headerName: 'UPI Payment', dataType:"string",field: "UPI Payment", headerSx: { textAlign:"left",minWidth: "120px" }, showString:faBullseye,allowSorting:false,showfilter: false },
  { headerName: 'Is Cheque', dataType:"string",field: "Is Cheque", headerSx: { textAlign:"left",minWidth: "120px" }, showString:faBullseye,allowSorting:false,showfilter: false },
  { headerName: 'Modified By', dataType:"string",field: "ModifiedBy", headerSx: { textAlign:"left",minWidth: "216px" }, showString:faBullseye,allowSorting:true,showfilter: false },
  { headerName: 'Modified Date & Time', dataType:"time",field: "ModifiedDateTime", headerSx: { textAlign:"center",minWidth: "216px" }, showString:faBullseye,allowSorting:true,showfilter: false },
]

//
export const waybillFormatPageTab = ['Standard Ticket Format', 'CUSTOMIZE Ticket Format']
export const waybillFormatPageTabIds = (index) => {
  return {
    id: `bookingPage-tab-${index}`,
    'aria-controls': `bookingPage-tabpanel-${index}`,
  }
}
export const formatTypeList = [
  { id: 0, name: 'BLANK' },
  { id: 1, name: 'PRE-PRINTED' },
]
export const statusList = [
  { id: 1, name: 'Active' },
  { id: 0, name: 'Inactive' },
]

//fontsize 10 to 36
export const fontSizeArray = Array.from({ length: 27 }, (_, index) => ({ id: index + 10 }))

export const imgList = [
  { id: 1, name: 'Logo' },
  { id: 2, name: 'QR' },
]
export const ratioList = [
  { id: 1, name: '1:1' },
  { id: 2, name: '4:1' },
  { id: 3, name: '1:2' },
]
export const labelList = [
  { id: 1, name: 'LR No.' },
  { id: 2, name: 'From' },
  { id: 3, name: 'To' },
  { id: 4, name: 'Quantity' },
]
export const getUseableArea = (containerId, margins) => {
  const containerRect = document.getElementById(containerId).getBoundingClientRect()
  return {
    left: parseFloat(margins?.left || '0'),
    top: parseFloat(margins?.up || '0'),
    right: containerRect.width - parseFloat(margins?.right || '0'),
    bottom: containerRect.height - parseFloat(margins?.down || '0'),
  }
}
export const reportsPageTab = ['GST Invoice Configuration', 'Monthly Target']
export const reportsPageTabIds = (index) => {
  return {
    id: `autoTransPage-tab-${index}`,
    'aria-controls': `autoTransPage-tabpanel-${index}`,
  }
}

export const partyMasterPageTabs = [{name:"Party Config.",JobID:1},{name:"Corporate Rate Matrix",JobID:2},{name:"Party Rate Matrix",JobID:3},]
export const partyMasterPageTabIds = (index) => {
  return {
    id: `partyMasterPage-tab-${index}`,
    'aria-controls': `partyMasterPage-tabpanel-${index}`,
  }
}

